interface LogoIconProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function LogoIcon({ className, size = "md" }: LogoIconProps) {
  const sizeClasses = {
    sm: "w-10 h-10",
    md: "w-12 h-12",
    lg: "w-14 h-14",
  };

  return (
    <div className={`${sizeClasses[size]} ${className || ""}`}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FBBF24" />
            <stop offset="50%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#D97706" />
          </linearGradient>
        </defs>
        
        <rect width="48" height="48" rx="12" fill="url(#logoGradient)" />
        
        <path 
          d="M24 10C18.48 10 14 14.48 14 20C14 23.52 15.86 26.58 18.64 28.26C19.1 28.54 19.4 29.04 19.4 29.58V31C19.4 31.55 19.85 32 20.4 32H27.6C28.15 32 28.6 31.55 28.6 31V29.58C28.6 29.04 28.9 28.54 29.36 28.26C32.14 26.58 34 23.52 34 20C34 14.48 29.52 10 24 10Z" 
          fill="white"
        />
        
        <rect x="20" y="34" width="8" height="2" rx="1" fill="white" opacity="0.9" />
        <rect x="21" y="37" width="6" height="2" rx="1" fill="white" opacity="0.8" />
        
        <path d="M24 6V8" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        <path d="M32.5 11.5L31 13" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        <path d="M15.5 11.5L17 13" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        <path d="M38 20H36" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        <path d="M12 20H10" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
      </svg>
    </div>
  );
}

export function Logo({ showText = true, size = "md" }: { showText?: boolean; size?: "sm" | "md" | "lg" }) {
  return (
    <div className="flex items-center gap-3">
      <LogoIcon size={size} />
      {showText && <span className="font-semibold">Світлодім</span>}
    </div>
  );
}
